var _path, _path2, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNpsSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49998 14.6673C12.1819 14.6673 15.1666 11.6825 15.1666 8.00065C15.1666 4.31875 12.1819 1.33398 8.49998 1.33398C4.81808 1.33398 1.83331 4.31875 1.83331 8.00065C1.83331 11.6825 4.81808 14.6673 8.49998 14.6673Z",
    stroke: "#C90000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79937 11.4478C4.54677 11.3191 4.44404 11.008 4.5997 10.771C4.97568 10.1987 5.47427 9.71432 6.06169 9.35435C6.79551 8.90466 7.63938 8.66667 8.50002 8.66667C9.36066 8.66667 10.2045 8.90466 10.9383 9.35435C11.5258 9.71432 12.0244 10.1987 12.4003 10.771C12.556 11.008 12.4533 11.3191 12.2007 11.4478C11.9481 11.5765 11.6417 11.4733 11.4788 11.2413C11.1938 10.8355 10.8278 10.4907 10.4019 10.2297C9.82954 9.87897 9.17132 9.69333 8.50002 9.69333C7.82872 9.69333 7.1705 9.87897 6.59813 10.2297C6.17224 10.4907 5.80623 10.8355 5.52124 11.2413C5.3583 11.4733 5.05198 11.5765 4.79937 11.4478Z",
    fill: "#C90000"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.83331,
    cy: 7.66602,
    r: 1,
    fill: "#C90000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.1667,
    cy: 7.66602,
    r: 1,
    fill: "#C90000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpsSad);
export default __webpack_public_path__ + "static/media/NpsSad.55abeaf6.svg";
export { ForwardRef as ReactComponent };